import barChart from './bar-chart.js'
import doughnutChart from './doughnut-chart.js'
import horizontalBarChart from './horizontal-bar-chart.js'
import lineChart from './line-chart.js'
import mixedChart from './mixed-chart.js'
import pieChart from './pie-chart.js'
import polarAreaChart from './polar-area-chart.js'
import radarChart from './radar-chart.js'

export default [
  barChart,
  horizontalBarChart,
  lineChart,
  mixedChart,
  pieChart,
  doughnutChart,
  polarAreaChart,
  radarChart
]
